import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FullPageMessage } from "./FullPageMessage";
import { useAuth } from "./useAuth";

/** Shown to signed-in users without a role until a platform admin approves them. */
export default function PendingApprovalPage() {
  const { me, isPending, reloadMe, logout } = useAuth();
  const [checking, setChecking] = useState(false);

  if (!isPending) return <Navigate to="/" replace />;

  return (
    <FullPageMessage title="Your account is waiting for approval">
      <p>
        You are signed in as <span className="font-medium text-foreground">{me?.email}</span>. An
        MDF administrator will give you access to your organisation's modules.
      </p>
      <div className="mt-5 flex justify-center gap-2">
        <Button
          variant="outline"
          disabled={checking}
          onClick={async () => {
            setChecking(true);
            await reloadMe();
            setChecking(false);
          }}
        >
          {checking ? "Checking…" : "Check again"}
        </Button>
        <Button variant="ghost" onClick={() => void logout()}>
          Sign out
        </Button>
      </div>
    </FullPageMessage>
  );
}
